import React from "react";

const SubmitSuccess = () => {
  const handleBackClick = () => {
    window.location.href = "https://www.greenmanopen.com";
  };

  return (
    <div className="container mt-5">
      <div className="alert alert-success" role="alert">
        <strong>Success!</strong> Your page has been submitted successfully.
      </div>
      <button className="btn btn-primary mt-3" onClick={handleBackClick}>
        Go to Greenman Open
      </button>
    </div>
  );
};

export default SubmitSuccess;
